import data from "../../../../../src/Details.docs.json";
import * as React from 'react';
export default {
  data,
  React
};